import { styled, css } from 'styled-components'
import { motion } from 'framer-motion'
import { FLYOUT_Z_INDEX } from 'consts/zIndex'

interface IFlyoutWrapperProps {
  $coords: { top: number; left: number }
  $isPositionCoordsChangedAfterRender: boolean
}

export const FlyoutWrapper = styled(motion.div)<IFlyoutWrapperProps>`
  position: fixed;
  z-index: ${FLYOUT_Z_INDEX + 1};
  height: auto;
  box-sizing: border-box;
  border-radius: 4px;
  ${({ $coords }) => css`
    top: ${$coords.top}px;
    left: ${$coords.left}px;
  `};
  ${({ $isPositionCoordsChangedAfterRender }) =>
    $isPositionCoordsChangedAfterRender &&
    css`
      transition:
        top 0.2s linear,
        left 0.2s linear;
    `}
  box-shadow: 0px 4px 10px 0px #1b55d847;
`
